<template>
  <div :class="className" ref="searchBox">
    <div class="search-icon" @click="runSearch"></div>
    <div class="input" ref="inputBox">
      <input
        type="text"
        autocomplete="off"
        placeholder="Search artist, city, country"
        v-model="search"
        ref="input"
      />
      <svg svg-inline="" :class="svgClassName" @click="close" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="#969696" d="M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm.707-7.5l2.829-2.828-.708-.708L7.5 6.793 4.672 3.964l-.708.708L6.793 7.5l-2.829 2.828.708.708L7.5 8.207l2.828 2.829.708-.708L8.207 7.5z"/></svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchArtist',
  data() {
    return {
      closed: true,
      showSVG: false,
      search: '',
    };
  },
  computed: {
    className() {
      if (this.$root.isDesktop) {
        return 'search-box opened';
      }

      return `search-box ${this.closed ? 'closed' : 'opened'}`;
    },
    svgClassName() {
      if (this.$root.isDesktop) {
        return 'icon white show';
      }

      return `icon white ${!this.showSVG ? 'hide' : 'show'}`;
    },
  },
  mounted() {
    this.$refs.searchBox.addEventListener('transitionend', this.toggleSVG);

    if (this.$root.isDesktop) {
      this.closed = false;
    }
  },
  beforeDestroy() {
    this.$refs.searchBox.removeEventListener('transitionend', this.toggleSVG);
    this.search = '';
    this.$store.commit('search', this.search);
  },
  methods: {
    runSearch() {
      if (this.closed) {
        this.closed = false;
      } else {
        this.commitSearch();
      }
    },
    close() {
      if (this.$root.isMobile) {
        this.closed = true;
      }

      this.search = '';
    },
    toggleSVG() {
      this.showSVG = !this.closed;

      if (this.showSVG) {
        this.$refs.input.focus();
      }
    },
    commitSearch() {
      this.$store.commit('search', this.search);
      this.$store.commit('orderBy', 'name');
    },
  },
  watch: {
    search() {
      this.commitSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
  .search-box {
    border: 1px solid #fff;
    background-color: #000;
    padding-left: 52px;
    position: absolute;
    height: 52px;
    width: 100%;
    -webkit-transition: width 300ms ease-in-out;
    transition: width 300ms ease-in-out;
    flex: 1;
    @media screen and (min-width: 991px) {
      max-width: 295px;
    }

    .search-icon {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 100%;
      width: 48px;
      background: #000 url('../assets/svg/search.svg') no-repeat 15px 14px;
      cursor: pointer;
    }

    &.closed {
      width: 45px;
      -webkit-transition: width 300ms ease-in-out;
      transition: width 300ms ease-in-out;

      .input {
        width: 0;
        max-height: 20px;
        display: none;
      }
    }

    .input {
      margin-left: -2px;
      display: block;

      input {
        background-color: #000;
        border: 0;
        color: #fff;
        width: calc(100% - 35px);
        margin-right: 5px;
        margin-top: 12px;

        &::placeholder {
          color: #fff;
        }

        &:focus {
          outline: none;
        }
      }
    }

    .icon.search {float: left;}
    .hide {display: none;}
    .show {display: inline;}
    .icon {cursor: pointer;}
  }
</style>
